import React from 'react';
import {SignInComponent} from '../../components';

export const SignIn: React.FC = React.memo(() => {
  return <SignInComponent />;
});
